$(document).ready(function() {
  if ($('.cart-link[data-action="open-drawer"]')) {
    $('.cart-link[data-action="open-drawer"]').on('click', function (event) {
    event.preventDefault();
    var drawerId = $(this).data('drawer-id');
    var $drawer = $('#' + drawerId);
    if ($drawer.length) {
      $drawer.addClass('animate active');
        $('body').addClass('overflow-hidden');
      }
    });
  }
  
  $('.hamburger-menu').on('click', function() {
    $('.mobile-menu-overlay').addClass('active');
  });
  
  $('.close-menu').on('click', function() {
    $('.mobile-menu-overlay').removeClass('active');
  });

  const currentPath = window.location.pathname;
  $('.mobile-menu-link, .desktop-link').each(function() {
    const linkPath = $(this).attr('href');
    if (currentPath === linkPath) {
      $(this).addClass('active');
    }
  });

  const pageLinks = {
    'page-home-link': 1,
    'page-lookbook-link': 2,
    'page-mot-link': 4,
    'page-campaign-link': 6
  };

  function bindMenuClicks() {
    $('.main-nav .menu-item div').on('click', function() {
      const linkId = $(this).attr('data-id');
  
      if (linkId === 'page-shop-link') {
        window.location.href = '/collections/all';
      } else if (linkId === 'page-info-link') {
        window.location.href = '/pages/info';
      } else {
        const targetPage = pageLinks[linkId];
        if (targetPage) {
          $('#flipbook').turn('page', targetPage);
  
          $('.main-nav .menu-item div').removeClass('active');
          $(this).addClass('active');
          
          let newUrl = '';
          let newTitle = '';
  
          if (linkId !== 'page-home-link') {
            newUrl = window.location.origin + '/pages/' + linkId.replace('page-', '').replace('-link', '');
            
            // Determine the new title based on the linkId
            if (linkId === 'page-lookbook-link') {
              newTitle = 'Lookbook';
            } else if (linkId === 'page-campaign-link') {
              newTitle = 'Campaign';
            } else if (linkId === 'page-mot-link') {
              newTitle = 'MOT';
            }
  
          } else {
            newUrl = window.location.origin + '/';
            newTitle = 'Home';
          }
  
          if (newTitle) {
            newTitle += ' - Beautiful Struggle';
            document.title = newTitle;
            $('meta[name="title"]').attr('content', newTitle);
          }
  
          history.pushState({ page: targetPage }, '', newUrl);
        }
      }
    });
  
    $('.mag-link[data-page]').on('click', function(e) {
      e.preventDefault();
      const page = $(this).data('page');
      const linkId = $(this).attr('class').split(' ')[0];
  
      if (page) {
        $('#flipbook').turn('page', page);
        $('.main-nav .menu-item div').removeClass('active');
  
        let newUrl = '';
        let newTitle = '';
  
        if (linkId === 'lookbook-link') {
          $('.main-nav .menu-item div[data-id="page-lookbook-link"]').addClass('active');
          newUrl = '/pages/lookbook';
          newTitle = 'Lookbook';
        } else if (linkId === 'mot-link') {
          $('.main-nav .menu-item div[data-id="page-mot-link"]').addClass('active');
          newUrl = '/pages/mot';
          newTitle = 'MOT';
        } else if (linkId === 'campaign-link') {
          $('.main-nav .menu-item div[data-id="page-campaign-link"]').addClass('active');
          newUrl = '/pages/campaign';
          newTitle = 'Campaign';
        }
  
        if (newUrl && newTitle) {
          newTitle += ' - Beautiful Struggle';
          document.title = newTitle;
          $('meta[name="title"]').attr('content', newTitle);
          history.pushState({ page: page }, '', newUrl);
        }
      }
    });
  }

   if ($("#flipbook")) {
      bindMenuClicks();
   }

  $('.mobile-facets__open').on('click', function () {
      if ($(window).width() <= 1023) {
        $('html, body').animate({ scrollTop: 70 }, 800);
      }
    });
});
